import {
	pinStickyRightColumns,
	getStickyRightIdsFromColumns,
	getLeafIdsFromColumns,
} from '../components/smartTable/pinStickyColumns';

/**
 * Encabezados de Excel en el orden de columnas del SmartTable, alineados con lo visible:
 * - columna visible (`columnVisibility`)
 * - tiene `meta.excelHeaders` (claves que espera el backend en `excelColumns`)
 * - `meta.enableExcel !== false` (p. ej. columnas solo UI con `enableExcel: false`)
 *
 * Las claves deben coincidir con el whitelist del endpoint que genera el Excel.
 */
export const getOrderedExcelHeadersForExport = (columnDefs, view) => {
	const leafIds = getLeafIdsFromColumns(columnDefs);
	const stickyRightIds = getStickyRightIdsFromColumns(columnDefs);
	const columnOrder = pinStickyRightColumns(
		view.columnOrder?.length ? view.columnOrder : leafIds,
		leafIds,
		stickyRightIds,
	);
	const visibility = view.columnVisibility || {};
	const out = [];
	const seen = new Set();
	for (const id of columnOrder) {
		if (visibility[id] === false) continue;
		const def = columnDefs.find((c) => c.id === id);
		if (def?.meta?.enableExcel === false) continue;
		const headers = def?.meta?.excelHeaders;
		if (!headers?.length) continue;
		for (const h of headers) {
			if (!seen.has(h)) {
				seen.add(h);
				out.push(h);
			}
		}
	}
	return out;
};
